import MentoringAllRequests from './MentoringAllRequests.vue';

export default MentoringAllRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/allrequests/index.ts